// 全网热瓜 网站 mock 数据
// 首页聚焦 / 热搜榜 / 事件内容集合

export interface HotItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  delta: string;
  trend: "up" | "down" | "flat";
}

export const hotRankList: HotItem[] = [
  { rank: 1, title: "带货主播「阿哲严选」售假风波出现反转新证据", tag: "热", heat: "986.2万", delta: "较昨日 +212%", trend: "up" },
  { rank: 2, title: "顶流歌手与经纪公司解约之争，工作室深夜再发声", tag: "沸", heat: "874.5万", delta: "较昨日 +158%", trend: "up" },
  { rank: 3, title: "探店博主「老杨逛吃」抄袭争议，被扒出三年旧账", tag: "热", heat: "653.9万", delta: "较昨日 +96%", trend: "up" },
  { rank: 4, title: "某品牌联名被指「借壳营销」，网友晒出对比图", tag: "新", heat: "498.2万", delta: "首次上榜", trend: "up" },
  { rank: 5, title: "电竞选手转会闹乌龙，俱乐部回应「内部流程失误」", tag: "热", heat: "412.7万", delta: "较昨日 -8%", trend: "down" },
  { rank: 6, title: "素人爆款歌曲被质疑借鉴，制作人晒出工程文件", tag: "新", heat: "356.4万", delta: "较昨日 +45%", trend: "up" },
  { rank: 7, title: "塌房网红直播道歉泪洒现场，弹幕争议两极分化", tag: "热", heat: "302.8万", delta: "较昨日 -12%", trend: "down" },
  { rank: 8, title: "某剧组路透照泄露风波，官方发声明呼吁理智追星", tag: "沸", heat: "276.3万", delta: "较昨日 +67%", trend: "up" },
  { rank: 9, title: "主播「木子李」回应学历争议，晒出证书原件", tag: "新", heat: "198.6万", delta: "首次上榜", trend: "up" },
  { rank: 10, title: "粉丝应援打投乱象被点名，后援会紧急整改", tag: "热", heat: "145.9万", delta: "较昨日 -3%", trend: "flat" },
];